import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MediaMenu, MediaService } from '@ribera-web/home-data-access';

@Component({
  selector: 'lib-footer',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer implements OnInit {
  private mediaService = inject(MediaService);

  currentYear = new Date().getFullYear();

  socialMedia: MediaMenu[] = [];

  ngOnInit(): void {
    this.loadSocialMedia();
  }

  loadSocialMedia() {
    console.log('📡 Llamando a findAllMenu(10)');

    this.mediaService.findAllMenu(10).subscribe({
      next: (res) => {
        console.log('✅ Respuesta completa:', res);

        this.socialMedia = res.filter((item) => item.mediaTypeId === 25);

        console.log('🎯 Redes sociales filtradas:', this.socialMedia);
      },
      error: (err) => {
        console.error('❌ Error cargando redes sociales:', err);
      },
    });
  }

  getSocialUrl(id: number): string {
    return this.socialMedia.find((item) => item.mediaId === id)?.url || '#';
  }
}
